export default __webpack_public_path__ + "static/media/016-shark.961cc5e1.svg";